export default "/build/frontend/fonts/vendor/@fontsource/inter/files/inter-vietnamese-400-normal.woff2?44c9df135eec470b0ab6aa836ba2318d";